import NoticeForm from '../components/NoticeForm';
import useNewNotice from './useNewNotice';

export default function NewNotice() {
    const { handleSubmit } = useNewNotice();

    return (
        <NoticeForm action='Adicionar' onSubmit={handleSubmit} />
    )
}
    